// @flow

import React from "react";
import { List, Map } from "immutable";
import { withStyles } from "@material-ui/core/styles";
import MaterialList from "@material-ui/core/List";
import NestedListItem from "components/NestedListItem";

const styles = (theme) => ({
  list: {
    width: "100%",
    maxWidth: 250,
    background: theme.palette.background.paper,
  },
  drawerInner: {
    width: 250,
  },
});

type Props = {
  classes: Object,
  items: List<Map<string, any>>,
  pathname: string,
  dispatch: (Object) => void,
};

const DrawerBody = ({ classes, items, pathname, dispatch }: Props) => {
  return (
    <div className={classes.drawerInner}>
      <MaterialList
        className={classes.list}
        dense={true}
        data-test="data-test-drawer-head"
      >
        {items.map((value, index) => {
          return (
            <NestedListItem
              item={value}
              key={index}
              pathname={pathname}
              dispatch={dispatch}
            />
          );
        })}
      </MaterialList>
    </div>
  );
};

export default withStyles(styles)(DrawerBody);
